// src/components/Customers/CustomerDetails.jsx
import React from 'react';

export default function CustomerDetails({ customer, onClose, onUpdate }) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Name</label>
          <p className="mt-1 text-sm text-gray-900">{customer?.name}</p>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Phone</label>
          <p className="mt-1 text-sm text-gray-900">{customer?.phone}</p>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <p className="mt-1 text-sm text-gray-900">{customer?.email || 'N/A'}</p>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Current Balance</label>
          <p className="mt-1 text-sm font-semibold text-red-600">KES {customer?.current_balance?.toLocaleString()}</p>
        </div>
        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700">Address</label>
          <p className="mt-1 text-sm text-gray-900">{customer?.address || 'N/A'}</p>
        </div>
      </div>
      <div className="flex space-x-3 pt-4">
        <button onClick={onClose} className="btn-secondary">Close</button>
      </div>
    </div>
  );
}